"use client";

import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

/**
 * Éléments communs aux démos du glossaire du business en ligne.
 *
 * Les sept premières démos (glossaire IA) répètent chacune ce cadre. Sept de
 * plus auraient fait quatorze copies de la même chose, d'où cette mise en
 * commun. Les contraintes qu'elle encode sont documentées dans
 * docs/glossaries.md et faciles à perdre de vue :
 *
 * - text-base leading-normal sur la racine : le conteneur de contenu porte
 *   sm:text-lg leading-8, hérité par tout ce qu'on insère.
 * - Le titre est un <div>, jamais un <h3> : .dynamic-content h3 impose
 *   font-size 1.5rem avec une spécificité que les utilitaires ne battent pas.
 */
export function Frame({ icon, title, children }) {
    return (
        <div className="my-8 rounded-2xl border border-gray-200/70 dark:border-white/10 bg-white/60 dark:bg-white/[0.03] p-5 sm:p-6 text-base leading-normal">
            <div className="flex items-center gap-2 mb-5">
                <SolarIcon name={icon} className="w-5 h-5 text-primary" />
                <div className="font-bold dark:text-white text-base leading-snug">
                    {title}
                </div>
            </div>
            {children}
        </div>
    );
}

export function Slider({ label, value, onChange, min, max, step = 1, display }) {
    return (
        <div>
            <div className="flex justify-between items-baseline mb-1.5 gap-3">
                <label className="text-sm text-gray-600 dark:text-lightBlue mb-0">
                    {label}
                </label>
                <span className="text-sm font-bold tabular-nums dark:text-white shrink-0">
                    {display ?? value}
                </span>
            </div>
            <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={(e) => onChange(Number(e.target.value))}
                className="w-full accent-primary cursor-pointer"
            />
        </div>
    );
}

export function Verdict({ tone, children }) {
    const tones = {
        good: "text-green-700 dark:text-green-400",
        warn: "text-amber-600 dark:text-amber-400",
        bad: "text-red-600 dark:text-red-400",
        neutral: "text-gray-600 dark:text-lightBlue",
    };
    return (
        <p className={`text-sm mb-0 mt-4 ${tones[tone] || tones.neutral}`}>
            {children}
        </p>
    );
}

export function Note({ children }) {
    return (
        <p className="text-xs text-gray-500 dark:text-lightBlue/70 mb-0 mt-4">
            {children}
        </p>
    );
}

export const money = (v, lang) =>
    `${Math.round(v).toLocaleString(lang === "fr" ? "fr-FR" : "en-US")} €`;
